import { FC, SVGProps } from "react";
import { DewuLogo } from "src/components/Icons/DewuLogo";
import { DouyinLogo } from "src/components/Icons/DouyinLogo";
import { JdLogo } from "src/components/Icons/JdLogo";
import { PinduoduoLogo } from "src/components/Icons/PinduoduoLogo";
import { SuningLogo } from "src/components/Icons/SuningLogo";
import { TaobaoLogo } from "src/components/Icons/TaobaoLogo";
import { XiaohongshuLogo } from "src/components/Icons/XiaohongshuLogo";

export interface ShihuoStoreInfo {
  label: string;
  color: string;
  Icon?: FC<SVGProps<SVGSVGElement>>;
}

const FALLBACK_COLOR = "var(--g-color-base-misc-heavy)";

export const SHIHUO_STORES: Record<string, ShihuoStoreInfo> = {
  淘宝: { label: "Taobao", color: "#FF4400", Icon: TaobaoLogo },
  天猫: { label: "Tmall", color: "#FF0036" },
  京东: { label: "JD", color: "#E1251B", Icon: JdLogo },
  抖音: { label: "Douyin", color: "#FE2C55", Icon: DouyinLogo },
  拼多多: { label: "Pinduoduo", color: "#E22E1F", Icon: PinduoduoLogo },
  唯品会: { label: "Vipshop", color: "#F10180" },
  得物: { label: "Dewu", color: "#01C2C3", Icon: DewuLogo },
  苏宁: { label: "Suning", color: "#FFAA00", Icon: SuningLogo },
  苏宁易购: { label: "Suning", color: "#FFAA00", Icon: SuningLogo },
  小红书: { label: "Xiaohongshu", color: "#FF2442", Icon: XiaohongshuLogo },
  网易严选: { label: "Yanxuan", color: "#B4282D" },
  考拉海购: { label: "Kaola", color: "#E64D3D" },
  "95分": { label: "95fen", color: "#5B8FF9" },
  官方: { label: "Official", color: "#8A8A8A" },
  官网: { label: "Official", color: "#8A8A8A" },
};

const STORE_BY_LABEL: Record<string, ShihuoStoreInfo> = Object.fromEntries(
  Object.values(SHIHUO_STORES).map((info) => [info.label, info]),
);

export const shihuoStoreLabel = (store: string): string =>
  SHIHUO_STORES[store]?.label ?? store;

export const shihuoStoreColor = (label: string): string =>
  STORE_BY_LABEL[label]?.color ?? FALLBACK_COLOR;

export const shihuoStoreIcon = (
  label: string,
): FC<SVGProps<SVGSVGElement>> | undefined => STORE_BY_LABEL[label]?.Icon;
